import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 16px 48px;
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.background_white};
  border: 1px solid ${({ theme }) => theme.colors.primary_100};
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2 {
    margin: 0 0 8px 0;
    font-size: 1.25rem;
    color: ${({ theme }) => theme.colors.secondary};
  }
  p.description {
    margin: 0 0 16px 0;
    color: ${({ theme }) => theme.colors.text_gray};
    min-height: 44px;
  }
  .price {
    display: flex;
    align-items: baseline;
    color: ${({ theme }) => theme.colors.primary};
    gap: 6px;
    margin-bottom: 16px;
  }
  .value {
    font-size: 1.75rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary};
  }
  .cycle {
    color: ${({ theme }) => theme.colors.text_gray};
    font-size: 0.95rem;
  }
  ul.features {
    margin: 12px 0 20px;
    padding-left: 18px;
    color: ${({ theme }) => theme.colors.text_gray};
  }
`;

export const SinglePlanCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 400px;
  margin: 0 auto;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  }

  h2 {
    margin: 0 0 12px 0;
    font-size: 1.75rem;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
    text-align: center;
  }
  p.description {
    margin: 0 0 24px 0;
    color: ${({ theme }) => theme.colors.text_gray};
    font-size: 1.1rem;
    text-align: center;
    min-height: auto;
  }
  .price {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 24px;
    justify-content: center;
  }
  .value {
    font-size: 2.5rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary};
  }
  .cycle {
    color: ${({ theme }) => theme.colors.text_gray};
    font-size: 1.1rem;
  }
  ul.features {
    margin: 12px 0 20px;
    padding-left: 18px;
    color: ${({ theme }) => theme.colors.text_gray};
  }
`;

export const Banner = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.primary_100};
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 12px;
  padding: 14px 16px;
  margin: 12px 0 24px;
`;

export const WarningBanner = styled.div`
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.primary_100},
    ${({ theme }) => theme.colors.primary_100}
  );
  border: 1px solid ${({ theme }) => theme.colors.primary_100};
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 12px;
  padding: 16px 20px;
  margin: 12px 0 24px;
  display: flex;
  align-items: center;
  gap: 12px;

  .icon {
    font-size: 1.5rem;
    color: #f59e0b;
  }

  .content {
    flex: 1;

    h3 {
      margin: 0 0 8px 0;
      font-size: 1.1rem;
      font-weight: 600;
    }

    p {
      margin: 0;
      font-size: 0.95rem;
      line-height: 1.4;
    }
  }
`;

export const DisabledCard = styled(Card)`
  opacity: 0.6;
  cursor: not-allowed;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.colors.background_white};
    border-radius: 12px;
    pointer-events: none;
  }
`;

export const DisabledSinglePlanCard = styled(SinglePlanCard)`
  opacity: 0.6;
  cursor: not-allowed;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 12px;
    pointer-events: none;
  }
`;
